import { zod4Resolver } from 'mantine-form-zod-resolver'
import { useForm } from '@mantine/form'
import { faqValidation } from './validation'

export const useFaqForm = () => {
  return useForm({
    mode: 'controlled',
    validate: zod4Resolver(faqValidation()),
    initialValues: {
      question: '',
      answer: '',
      keyword: [],
    }
  })
}

